/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect, useState } from 'react';
import { Dialog, Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import {
  SortableHandle,
  SortableElement,
  SortableContainer,
  arrayMove
} from 'react-sortable-hoc';
import { map, filter, differenceBy, includes } from 'lodash';
import styles from './columnCustomizer.module.scss';
import Button from '../../../../components/button';
import Checkbox from '../../../../components/checkbox';
import CloseIcon from '../../../../icons/closeIcon.svg';
import search from '../../../../icons/search.svg';
import handle from '../../../../icons/inspection-icons/Droper.svg';

const DragHandle = SortableHandle(() => (
  <img className={styles.handle} src={handle} alt="" />
));

const SortableItem = SortableElement(({ column, removeColumn, isGate }) => (
  <Box className={styles.content} display="flex" alignItems="center">
    <DragHandle />
    <div className={styles.verticalLine} />
    {isGate && column?.formatId ? (
      <p className={styles.name}>
        <FormattedMessage id={column.formatId} defaultMessage={column.formatId} />
      </p>
    ): (
      <p className={styles.name}>{column.title}</p>
    )}
    <img
      className={styles.close}
      src={CloseIcon}
      alt=""
      onClick={() => removeColumn(column)({ target: { checked: false } })}
    />
  </Box>
));

const SortableList = SortableContainer(({ columns, removeColumn, isGate }) => (
  <div>
    {map(columns, (column, i) => (
      <SortableItem
        key={column.id}
        column={column}
        removeColumn={removeColumn}
        index={i}
        isGate={isGate}
      />
    ))}
  </div>
));

const ColumnCustomizer = ({ cols, onModify, onClose, isADP, columnData, isforms }) => {
  const [columns, setColumns] = useState(cols || []);
  const [selectedCols, setSelectedCols] = useState([]);
  const [searchText, setSearchText] = useState('');


  const onSortEnd = ({ oldIndex, newIndex }) => {
    let sortedColumns = arrayMove(selectedCols, oldIndex, newIndex);
    sortedColumns = map(sortedColumns, (col, idx) => ({ ...col, index: idx }));
    setSelectedCols(sortedColumns);
  };

  const onChange = column => (e) => {
    column.selected = e.target.checked;
    const updatedColumns = columns?.map(col => (col.id === column.id ? { ...col, selected: e.target.checked } : col));
    setColumns(updatedColumns);
};

  const onAdd = () => {
    const diffArray = differenceBy(columns, selectedCols, 'id');
    const newArray = [...selectedCols, ...diffArray];
    if (isADP || isforms) {
      selectedCols.length > 8 ? alert('You can only select maximum 8 columns!') : (selectedCols.length < 3)
        ? alert('Please select at least 3 columns to display on the grid view') : onModify(newArray);
    } else {
      columnData(newArray);
    }
  };

  useEffect(() => {
    const newSelectedCols = filter(columns, ['selected', true])
      ?.filter(col => col?.id !== undefined);
    const existingIds = map(selectedCols, 'id');
    const newSelectedColsFiltered = newSelectedCols?.filter(col => !existingIds?.includes(col?.id)) || [];
    const unremovedIds = columns?.map((i) => {
      if (i?.selected) {
        return i?.id;
      }
      return null;
    });
    setSelectedCols([...selectedCols, ...newSelectedColsFiltered]?.filter(i => unremovedIds?.includes(i?.id)));
  }, [columns]);

  return (
    <Dialog
      open
      classes={{
        root: styles.modal,
        container: styles.muiContainer,
        paper: styles.muiPaper
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={styles.headerBox}
      >
        <FormattedMessage id={isADP || isforms
          ? 'Select columns to View' : 'forms.columns.choose'}>
           <p className={styles.headerText}>Select columns to View</p>
        </FormattedMessage>
        <div className={styles.iconGroup}>
          <img
            src={CloseIcon}
            className={styles.close}
            alt="closeIcon"
            onClick={onClose}
          />
        </div>
      </Box>
      <Box className={styles.panels} display="flex">
        <div className={styles.leftPanel}>
          <div className={styles.searchBox}>
            <FormattedMessage
              id="forms.columns.search"
              defaultMessage="Search Columns"
            >
              {txt => (
                <input
                  type="text"
                  placeholder={txt}
                  className={styles.searchInput}
                  onChange={e => setSearchText(e.target.value)}
                />
              )}
            </FormattedMessage>
            <img className={styles.searchIcon} src={search} alt="" />
          </div>
          <div className={styles.checkboxes}>
            {map(
              columns,
              column => includes(column?.title, searchText) && (
              <Checkbox
                formatId={column?.formatId}
                label={column?.title}
                checked={column?.selected}
                onChange={onChange(column)}
              />
              )
            )}
          </div>
        </div>
        <div className={styles.rightPanel}>
          <FormattedMessage id="forms.columns.selectedColumns">
            {txt => <p className={styles.selectedColumns}>selected Columns</p>}
          </FormattedMessage>
          <SortableList
            useDragHandle
            columns={selectedCols}
            removeColumn={onChange}
            onSortEnd={onSortEnd}
          />
        </div>
      </Box>
      <Box display="flex" justifyContent="flex-end" className={styles.footer}>
        <div className={styles.modalBtnGroup}>
          <Button
            action="tertiary"
            translationID="inspections.new.cancelBtn"
            defaultText="Cancel"
            onClick={onClose}
          />
          <Button
            action="secondary"
            translationID={isADP || isforms
              ? 'workorders.list.filters.views.apply' : 'roles.privileges.actionAdd'}
            defaultText="Add"
            onClick={onAdd}
            ContentStyles={{ marginLeft: '25px' }}
          />
        </div>
      </Box>
    </Dialog>
  );
};

export default ColumnCustomizer;
